export default __webpack_public_path__ + "static/media/190629_192557_DSCN3050.76d11be2.JPG";